import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppRoute } from "../../routes/AppRoutes";
import { QUERY_KEY } from "../../types/query.types";

interface INavigationSlice {
  currentRoute: AppRoute,
  query: Record<QUERY_KEY, any>
}

export const NavigationSlice = createSlice({
  name: "navigation",
  initialState: {
    currentRoute: AppRoute.Products,
    query: {}
  } as INavigationSlice,
  reducers: {
    setRoute: (state, action: PayloadAction<AppRoute>) => {
      state.currentRoute = action.payload;
    },
    updateQuery: (state, action: PayloadAction<{ key: QUERY_KEY, value: any }>) => {
      const { key, value } = action.payload;
      state.query[key] = value;
    }
  }
});

export const { setRoute, updateQuery } = NavigationSlice.actions;

export default NavigationSlice.reducer;